<template xmlns="http://www.w3.org/1999/html">
  <div>
    <page-title/>
    <div container class="card" column="12"><br>
      <p><b>{{this.$route.query.userMessage}}</b> </p>
      <div grid="row wrap" column="12">
        <div v-html="final_page_html"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import PageTitle from './PageTitle'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'
  export default {
    mixins: [clientOnboardVerbiage],
    components: {
      PageTitle
    }
  }
</script>
